// ── Thumbnail rail scroll arrows (horizontal): adds arrows to thumbnails so users can scroll through thumbnails on product detail pages ──
(function () {
  function initThumbnailArrows() {
    const rails = document.querySelectorAll('.slideshow-controls__thumbnails-container');

    rails.forEach((rail) => {
      if (rail.closest('.thumbnail-scroll-wrapper')) return;

      const parent = rail.parentElement;
      if (!parent) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'thumbnail-scroll-wrapper';
      parent.insertBefore(wrapper, rail);

      // Left arrow
      const btnLeft = document.createElement('button');
      btnLeft.className = 'thumbnail-scroll-btn thumbnail-scroll-btn--left is-hidden';
      btnLeft.setAttribute('aria-label', 'Scroll thumbnails left');
      btnLeft.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15 18 9 12 15 6"></polyline></svg>`;

      // Right arrow
      const btnRight = document.createElement('button');
      btnRight.className = 'thumbnail-scroll-btn thumbnail-scroll-btn--right is-hidden';
      btnRight.setAttribute('aria-label', 'Scroll thumbnails right');
      btnRight.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="9 18 15 12 9 6"></polyline></svg>`;

      wrapper.appendChild(btnLeft);
      wrapper.appendChild(rail);
      wrapper.appendChild(btnRight);

      const scrollAmount = 200;

      btnLeft.addEventListener('click', () => {
        rail.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      btnRight.addEventListener('click', () => {
        rail.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      function updateButtons() {
        btnLeft.classList.toggle('is-hidden', rail.scrollLeft <= 0);
        btnRight.classList.toggle(
          'is-hidden',
          rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2
        );
      }

      rail.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();

      const images = rail.querySelectorAll('button');
      images.forEach((img) => img.addEventListener('load', updateButtons));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailArrows);
  } else {
    initThumbnailArrows();
  }

  const observer = new MutationObserver(() => initThumbnailArrows());
  observer.observe(document.body, { childList: true, subtree: true });
})();
// end of thumbnail row arrow code